module.exports = __webpack_public_path__ + "static/Gallery-3-59ec2a8771bf52bcaf6474f23e15ec26.jpg";